import { WorklistTaskComplete } from "@/features/worklist/components/WorklistTaskComplete";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const worklistCompleteSearchSchema = z.object({
    fromItemId: z.string().optional(),
    nextItemId: z.string().optional(),
    archived: z.boolean().optional(),
});

function WorklistCompletePage() {
    const { fromItemId, nextItemId, archived } = Route.useSearch();
    return <WorklistTaskComplete fromItemId={fromItemId} nextItemId={nextItemId} archived={archived} />;
}

export const Route = createFileRoute("/_app/worklist/complete")({
    component: WorklistCompletePage,
    validateSearch: (search) => worklistCompleteSearchSchema.parse(search),
});
